import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { environment } from 'src/environments/environment';
import { webSiteschemaService } from 'src/app/modules/shared/_services/website-schema.service';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';

@Injectable({
    providedIn: 'root',
})
export class DetailPageMetaService {
    private renderer2: Renderer2;

    constructor(
        private title: Title,
        private sharedService: SharedService,
        private rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private document: Document, private router: Router,
        private meta: Meta,private webSiteschema: webSiteschemaService
    ) {
        // Initialize the Renderer2 instance
        this.renderer2 = this.rendererFactory.createRenderer(null, null);
    }

    setMetas(tender: any) {
        this.meta.addTag({ "name": "robots", "content": "index,follow" });

        this.title.setTitle(
            (tender?.authority?.name || '') +
            (tender?.authorityShortName && tender?.authorityShortName !== 'NA' ? ' (' + tender.authorityShortName + ')' : '') +
            ' Tender - ' + (tender?.tenderTitle || '') +
            ' - ' + (tender?.state?.name || '') +
            ' | TenderShark'
        );

        if (this.sharedService.isServer) {
            let links = this.renderer2.createElement('link');
            links.rel = 'canonical';
            let href = environment.TENDER.BASE_URL + this.router.url.split('?')[0].toLowerCase();
            links.href = href;
            this.renderer2.appendChild(this.document.head, links);

            const imageUrl = "https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/Tender_Shark_logo.webp";

            const descriptionParts = [];
            const titleParts = [];
            if (tender?.authority?.name) {
                descriptionParts.push(tender.authority.name + (tender?.authorityShortName && tender?.authorityShortName !== 'NA' ? ' (' + tender.authorityShortName + ')' : '') + ' Tender');
                titleParts.push(tender.authority.name + (tender?.authorityShortName && tender?.authorityShortName !== 'NA' ? ' (' + tender.authorityShortName + ')' : '') + ' Tender');
            }
            if (tender?.tenderTitle) {
                descriptionParts.push(tender.tenderTitle);
                titleParts.push(tender.tenderTitle);
            }
            if (tender?.state?.name) {
                descriptionParts.push(tender.state.name);
                titleParts.push(tender.state.name);
            }
            if (tender?.bidSubmissionEndDate) {
                descriptionParts.push('Closing Date: ' + tender.bidSubmissionEndDate);
            }
            if (tender?.amount) {
                descriptionParts.push('Tender amount: INR ' + tender.amount);
            }
            const descriptionContent = descriptionParts.join(' - ');
            const titleContent = titleParts.join(' - ');
            this.meta.addTag({ name: "description", content: descriptionContent });
            this.meta.addTag({ name: "og:description", content: descriptionContent });
            this.meta.addTag({ name: "og:title", content: titleContent + ' | TenderShark' });
            this.meta.addTag({ "name": "og:site_name", "content": "TenderShark" });
            this.meta.addTag({ "name": "og:type", "content": "website" });
            this.meta.addTag({ "name": "og:url", "content": environment.TENDER.BASE_URL + this.router.url });
            this.meta.addTag({ "name": "og:image", "content": imageUrl });

            this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
            this.meta.updateTag({ name: 'twitter:site', content: '@tender_shark' });
            this.meta.updateTag({ name: 'twitter:title', content: titleContent + ' | TenderShark' });
            this.meta.updateTag({ name: 'twitter:description', content: descriptionContent });
            this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

            let tag = this.renderer2.createElement('script');
            tag.type = "application/ld+json";

            tag.text = this.getArticlesSchema(tender);
            this.renderer2.appendChild(this.document.head, tag);

            this.setBreadcrumbSchema(tender);
            this.webSiteschema.setWebSiteSchema();
        }
    }

    getArticlesSchema(tenderDetails: any) {
        let schemaObj = {
            "@context": "https://schema.org",
            "@type": "Event",
            "url": environment.TENDER.BASE_URL + this.router.url,
            "name": tenderDetails?.authority?.name,
            "startDate": tenderDetails?.bidSubmissionStartDate,
            "endDate": tenderDetails?.bidSubmissionEndDate,
            "location": {
                "@type": "Place",
                "name": tenderDetails?.location,
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": tenderDetails?.city?.name,
                    "postalCode": tenderDetails?.pinCode,
                    "addressRegion": tenderDetails?.state?.name,
                    "addressCountry": {
                        "@type": "Country",
                        "name": "India"
                    }
                }
            },
            "description": tenderDetails?.summary,
            "organizer": {
                "@type": "Organization",
                "name": tenderDetails?.authority?.name,
                "url": environment.TENDER.BASE_URL + this.router.url
            }
        }
        return JSON.stringify(schemaObj);
    }

    setBreadcrumbSchema(tender: any) {
        let tag = this.renderer2.createElement('script');
        tag.type = "application/ld+json";
        tag.text = this.getBreadcrumbSchema(tender)
        this.renderer2.appendChild(this.document.head, tag);
    }

    getBreadcrumbSchema(tenders: any) {
        let schemaObj = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 0, "item": environment.TENDER.BASE_URL, "name": "Home" },
                { "@type": "ListItem", "position": 1, "item": environment.TENDER.BASE_URL + '/all-tenders/active', "name": "Indian Tenders" },
                { "@type": "ListItem", "position": 2, "item": environment.TENDER.BASE_URL + '/' + tenders?.state?.link + '-tenders/active', "name": tenders?.state?.name },
                { "@type": "ListItem", "position": 3, "item": environment.TENDER.BASE_URL + '/authority/' + tenders?.authority?.link + '-tenders/active', "name": tenders?.authority?.name }
            ]
        }
        return JSON.stringify(schemaObj);
    }
}